

import React, { useEffect, useState } from 'react'
import '../css/layout.css'
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import socket from '../Components/socket'
import Rightcontainer from '../Components/Rightcontainer'
import Swal from 'sweetalert2'
import Header from '../Components/Header'
import { MdCheck, MdOutlineLogout, MdOutlineModeEdit, MdVerified, MdError, MdHourglassTop, MdSecurity } from 'react-icons/md'
import { BsPhone, BsDice5, BsTrophy, BsPeople } from 'react-icons/bs'

const Profile1 = () => {
  const [referral, setCode] = useState('')
  const [profile, setProfile] = useState()
  const [isNameEdit, setIsNameEdit] = useState(false);
  const [editedName, setEditedName] = useState("");
  const [total, setTotal] = useState(0)
  const history = useHistory()

  // ✅ Theme-Aligned Toast
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    background: '#000',
    color: '#FF9800'
  });

  const handleNameEdit = () => {
    setIsNameEdit(true);
    setEditedName(profile?.Name);
  };

  const logout = () => {
    let access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios.post(`https://api.rrludo.in/logout`, {}, { headers })
      .then(() => {
        localStorage.removeItem('token')
        history.push('/login')
        window.location.reload(true)
      })
  }

  const UserALL = () => {
    let access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios.get(`https://api.rrludo.in/me`, { headers })
      .then((res) => {
        setProfile(res.data)
        TotalGame(res.data._id)
      })
  }

  const UpdateProfile = async () => {
    const access_token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await axios.patch(`https://api.rrludo.in/user/edit`, { Name: editedName }, { headers });
      if (res.data === 'User name already exist!') {
        Toast.fire({ icon: 'error', title: res.data });
      } else {
        Toast.fire({ icon: 'success', title: 'Profile Updated' });
        UserALL();
        setIsNameEdit(false);
      }
    } catch (e) { console.error(e); }
  };

  const update_RefCode = async () => {
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    try {
      const res = await axios.patch(`https://api.rrludo.in/user/edit`, { referral }, { headers })
      if (res.status === 200) {
        UserALL();
        Toast.fire({
          icon: res.data.submit ? 'success' : 'error',
          title: res.data.msg || 'Invalid referral Code'
        });
      }
    } catch (e) { console.error(e); }
  }

  const TotalGame = (Id) => {
    let access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios.get(`https://api.rrludo.in/total/user/all/${Id}`, { headers })
      .then((res) => setTotal(res.data))
  }

  useEffect(() => { UserALL() }, [])

  const styles = {
    pageWrapper: {
      background: '#FFFDE7',
      minHeight: '100vh',
      color: '#000',
      fontFamily: "'Poppins', sans-serif",
      overflowX: 'hidden'
    },
    topHeader: {
      background: '#000',
      height: '140px',
      borderRadius: '0 0 40px 40px',
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      width: '100%'
    },
    avatarImg: {
      width: '110px',
      height: '110px',
      borderRadius: '30px',
      border: '5px solid #FFFDE7',
      objectFit: 'cover',
      background: '#fff',
      marginTop: '40px',
      boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
    },
    mainCard: {
      background: '#fff',
      borderRadius: '30px',
      padding: '60px 20px 25px',
      textAlign: 'center',
      boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
      border: '1px solid #FFF9C4',
      marginTop: '-30px',
      width: '100%'
    },
    kycBadge: (status) => ({
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '6px 16px',
      borderRadius: '50px',
      fontSize: '11px',
      fontWeight: '800',
      background: status === 'verified' ? '#E8F5E9' : '#FFEBEE',
      color: status === 'verified' ? '#2E7D32' : '#C62828',
      marginTop: '10px',
      textTransform: 'uppercase'
    }),
    statContainer: {
      background: '#000',
      borderRadius: '20px',
      padding: '15px',
      display: 'flex',
      justifyContent: 'space-around',
      marginTop: '20px'
    },
    infoRow: {
      background: '#fff',
      padding: '15px',
      borderRadius: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      border: '1px solid #FFF9C4',
      marginTop: '15px',
      cursor: 'pointer',
      width: '100%'
    },
    iconBox: {
      width: '40px',
      height: '40px',
      background: '#000',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#FF9800',
      flexShrink: 0
    },
    logoutBtn: {
      background: 'transparent',
      border: '2px solid #000',
      color: '#000',
      borderRadius: '15px',
      padding: '12px',

      fontWeight: '800',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      marginTop: '25px !important',
      transition: '0.3s'
    }
  };

  return (
    <>
      <Header user={profile} />
      <div style={styles.pageWrapper}>
        <div className="container">
          <div className="row justify-content-center">
            {/* Main Content Column */}
            <div className="col-12 col-md-8 col-lg-5 px-3 " style={{ marginBottom: "90px" }}>
              <div className="Orher_page_main_sections">

                {/* Header & Avatar */}
                <div style={styles.topHeader}>
                  <img
                    src={profile?.avatar ? `https://api.rrludo.in/${profile?.avatar}` : `/images/avatars/Avatar2.png`}
                    alt="Avatar"
                    style={styles.avatarImg}
                  />
                </div>

                {/* Profile Card */}
                <div style={styles.mainCard}>
                  {isNameEdit ? (
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <input
                        className="form-control form-control-sm w-50"
                        style={{ border: '2px solid #FF9800', borderRadius: '10px', fontWeight: '800', textAlign: 'center' }}
                        value={editedName}
                        onChange={(e) => setEditedName(e.target.value)}
                        autoFocus
                      />
                      <MdCheck size={24} color="#2E7D32" onClick={UpdateProfile} style={{ cursor: 'pointer' }} />
                    </div>
                  ) : (
                    <h4 className="mb-0 fw-bold">
                      {profile?.Name || "Player"}
                      <MdOutlineModeEdit
                        size={18}
                        style={{ background: '#FF9800', borderRadius: '5px', padding: '2px', marginLeft: '8px', cursor: 'pointer' }}
                        onClick={handleNameEdit}
                      />
                    </h4>
                  )}

                  <div style={styles.kycBadge(profile?.verified)}>
                    {profile?.verified === 'verified' ? <MdVerified /> : profile?.verified === 'pending' ? <MdHourglassTop /> : <MdError />}
                    {profile?.verified === 'verified' ? 'Verified Pro' : profile?.verified === 'pending' ? 'Pending' : 'Unverified'}
                  </div>

                  {/* Stats Bar */}
                  <div style={styles.statContainer}>
                    <div className="text-center">
                      <div style={{ color: '#fff', fontWeight: '800' }}>{profile?.wonAmount ?? 0}</div>
                      <div style={{ color: '#FF9800', fontSize: '10px', fontWeight: '700' }}>WON</div>
                    </div>
                    <div className="text-center" style={{ borderLeft: '1px solid #333', borderRight: '1px solid #333', padding: '0 15px' }}>
                      <div style={{ color: '#fff', fontWeight: '800' }}>{total ?? 0}</div>
                      <div style={{ color: '#FF9800', fontSize: '10px', fontWeight: '700' }}>BATTLES</div>
                    </div>
                    <div className="text-center">
                      <div style={{ color: '#fff', fontWeight: '800' }}>{profile?.referral_earning ?? 0}</div>
                      <div style={{ color: '#FF9800', fontSize: '10px', fontWeight: '700' }}>EARNED</div>
                    </div>
                  </div>
                </div>

                {/* Info Rows */}
                <div style={styles.infoRow}>
                  <div style={styles.iconBox}><BsPhone size={18} /></div>
                  <div className="text-start">
                    <div style={{ color: '#888', fontSize: '10px', fontWeight: '700' }}>MOBILE</div>
                    <div style={{ fontWeight: '800', fontSize: '14px' }}>+91 {profile?.Phone}</div>
                  </div>
                </div>

                {profile?.verified !== 'verified' && (
                  <div style={{ ...styles.infoRow, background: '#FF9800', borderColor: '#FF9800' }} onClick={() => history.push("/Kyc2")}>
                    <div style={{ ...styles.iconBox, background: '#000' }}><MdSecurity size={18} color="#FF9800" /></div>
                    <div className="text-start flex-grow-1">
                      <div style={{ fontWeight: '800', fontSize: '14px' }}>COMPLETE KYC</div>
                      <div style={{ fontSize: '10px', fontWeight: '700' }}>Verify to start withdrawals</div>
                    </div>
                  </div>
                )}

                {/* Referral Code */}
                {!profile?.referral && (
                  <div style={{ ...styles.infoRow, background: '#000', color: '#fff', flexDirection: 'column', alignItems: 'stretch' }}>
                    <div style={{ color: '#FF9800', fontSize: '10px', fontWeight: '800', marginBottom: '8px', textAlign: 'center' }}>USE REFERRAL CODE</div>
                    <div className="d-flex gap-2">
                      <input
                        className="form-control form-control-sm"
                        style={{ background: '#222', border: 'none', color: '#fff', borderRadius: '10px' }}
                        placeholder="Enter code"
                        value={referral}
                        onChange={(e) => setCode(e.target.value)}
                      />
                      <button onClick={update_RefCode} className="btn btn-sm btn-warning fw-bold px-3" style={{ borderRadius: '10px' }}>APPLY</button>
                    </div>
                  </div>
                )}

                <button style={styles.logoutBtn} onClick={logout} className="text-center mt-4 ">
                  LOGOUT ACCOUNT <MdOutlineLogout size={18} />
                </button>

                {/* <div className="text-center mt-4 mb-5" style={{ color: '#bbb', fontSize: '10px', fontWeight: '700', letterSpacing: '2px' }}>
                  VERSION 2.6.4 (SECURE)
                </div> */}
              </div>
            </div>

            {/* Right Container (Desktop Only) */}
            <div className="col-lg-4 d-none d-lg-block">
              <Rightcontainer />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Profile1